<template>
    <div>
        <div class="pt-2 pb-3 px-3">
            <h6
                style="font-family: MainFontBold, sans-serif;
                font-size: 16px;
                color: #2A2A2A;">
                Add-Ons
            </h6>
            <b-row>
                <b-col style="padding-top: 2px;"
                    @click="origin === 'new_product' ? addAttributeAdOn() : addAttributeAdOnEdit()" >
                    <img src="@/assets/images/icons/add.svg" style="cursor: pointer;" alt="Add Button" class="mr-2">
                    <label class="mb-0 add-attribute-button" style="cursor: pointer; position: absolute; top: 7px;">
                        Add Add-Ons
                    </label>
                </b-col>
                <b-col>
                    <b-button block variant="primary" class="generate-button shadow-none"
                        @click="origin === 'new_product' ? generate() : generateEdit()"
                        :disabled="enableGenerate || editingFromLocationsPage">
                        GENERATE
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <div role="tablist" style="border-bottom: 1px solid #e7eaf0;" v-if="origin==='new_product'">
            <b-card no-body
                :class="[
                    'border-left-0 border-right-0',
                    {'border-bottom-0': index == values.attributes.length - 1}
                ]"
                v-for="(attribute, index) in values.attributes" 
                :key="index">
                <b-card-header header-tag="header" class="py-1 px-3 pr-0 bg-white" role="tab">
                    <b-row no-gutters>
                        <b-col cols="1">
                            <div v-b-toggle="'accordion-' + index">
                                <img src="@/assets/images/icons/collapse.svg" alt="Collapsed Icon" class="collapse-icon when-closed">
                                <img src="@/assets/images/icons/expand.svg" alt="Expand Icon" class="expand-icon when-opened">
                            </div>
                        </b-col>
                        <b-col>
                            <b-form-group
                                :id="'attribute-group-' + index"
                                :label-for="'attribute-' + index"
                                class="mb-0">
                                <b-form-input
                                    :id="'attribute-' + index"
                                    placeholder="Enter Add-On Name"
                                    v-model="attribute.name"
                                    maxlength="30"
                                    :disabled="editingFromLocationsPage"
                                    class="border-0 shadow-none">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="1" v-if="!attribute.uuid">
                            <img src="@/assets/images/actions/delete.svg"
                                alt="Delete Button"
                                :class="['delete-button', {'not-allowed': origin == 'edit_product'}]"
                                @click="origin == 'new_product' ? deleteAttribute(index) : null">
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-collapse :id="'accordion-' + index"
                    visible
                    :accordion="'attribute-accordion-' + index"
                    role="tabpanel">
                    <div class="variation-container">
                        <div v-for="(variation, sub_index) in values.attributes[index].variations"
                            :key="variation.id"
                            class="variation py-1 px-3">
                            <b-row no-gutters>
                                <b-col>
                                    <b-form-group
                                        :id="'attribute-group-' + index"
                                        :label-for="'attribute-' + index"
                                        class="mb-0">
                                        <b-form-input :id="'attribute-' + index"
                                            placeholder="Enter Add-On Variation"
                                            maxlength="30"
                                            v-model="variation.name"
                                            :disabled="editingFromLocationsPage">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="1"
                                    v-if="values.attributes[index].variations.length > 1 && variation.action == 'create'"
                                    style="cursor: pointer;">
                                    <img
                                        src="@/assets/images/actions/delete.svg"
                                        alt="Delete Button"
                                        @click="deleteVariation({
                                            attribute: index,
                                            variation: sub_index
                                        })"
                                    >
                                </b-col>
                            </b-row>
                        </div>
                        <div class="variation px-3 add-variation">
                            <b-row no-gutters>
                                <b-col style="cursor: pointer;"
                                    @click="addVariation(index)">
                                    <img src="@/assets/images/icons/add.svg"
                                        alt="Add Button"
                                        class="add-variation-button mr-2">
                                    <label class="mb-0" style="position: absolute; top: 2px; cursor: pointer;">
                                        Add Option
                                    </label>   
                                </b-col>
                            </b-row>
                        </div>
                        <div class="py-2 px-3 pr-0 bg-white">
                            <b-form inline v-on:submit.prevent>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref">Maximum Selection</label>
                                <b-form-input
                                    type="number"
                                    style="width: 80px;"
                                    min="1"
                                    v-model="attribute.limit"
                                    max="10000000000"
                                    oninput="this.value = Math.abs(this.value)">
                                </b-form-input>
                            </b-form>
                        </div>
                    </div>
                </b-collapse>
            </b-card>
        </div>
        <div role="tablist" style="border-bottom: 1px solid #e7eaf0;" v-if="origin==='edit_product'">
            <b-card no-body
                :class="[
                    'border-left-0 border-right-0',
                ]"
                v-for="(attribute, index) in values" 
                :key="index">
                <b-card-header header-tag="header" class="py-1 px-3 pr-0 bg-white" role="tab">
                    <b-row no-gutters>
                        <b-col cols="1">
                            <div v-b-toggle="'accordion-add-on-' + index">
                                <img src="@/assets/images/icons/collapse.svg" alt="Collapsed Icon" class="collapse-icon when-closed">
                                <img src="@/assets/images/icons/expand.svg" alt="Expand Icon" class="expand-icon when-opened">
                            </div>
                        </b-col>
                        <b-col>
                            <b-form-group
                                :id="'attribute-group-add-on-' + index"
                                :label-for="'attribute-add-on-' + index"
                                class="mb-0"
                                
                                :invalid-feedback="errorMessage('product_attributes.' + index + '.name')"
                                :state="isValid('product_attributes.' + index + '.name')">
                                <b-form-input
                                    :id="'attribute-add-on-' + index"
                                    placeholder="Enter Add-On Name"
                                    maxlength="30"
                                    v-model="attribute.name"
                                    class="border-0 shadow-none"
                                    :disabled="attribute.uuid !== null">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="1" v-if="!attribute.uuid">
                            <img src="@/assets/images/actions/delete.svg"
                                alt="Delete Button"
                                :class="'delete-button'"
                                @click="deleteAttributeAdOnEdit(index)"
                            >
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-collapse :id="'accordion-add-on-' + index"
                    visible
                    :accordion="'attribute-accordion-add-on-' + index"
                    role="tabpanel">
                    <div class="variation-container">
                        <div v-for="(variation, sub_index) in values[index].add_ons"
                            :key="variation.id"
                            class="variation py-1 px-3">
                            <b-row no-gutters>
                                <b-col>
                                    <b-form-group
                                        :id="'attribute-group-add-on-' + index"
                                        :label-for="'attribute-add-on-' + index"
                                        class="mb-0">
                                        <b-form-input :id="'attribute-add-on-' + index"
                                            maxlength="30"
                                            placeholder="Enter Add-On Variation"
                                            v-model="variation.name"
                                            :disabled="variation.uuid !== null">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="1"
                                    :id="origin == 'edit_product' ? 'epopover-add-on-' + index + '-' + sub_index : 'popover-add-on-' + index + '-' + sub_index"
                                    style="cursor: pointer;"
                                    v-if="!variation.uuid">
                                    <img src="@/assets/images/actions/delete.svg"
                                        alt="Delete Button"
                                        :class="'delete-button'"
                                        @click="deleteVariationAdOnEdit({
                                            attribute: index,
                                            variation: sub_index
                                        })"
                                    >
                                </b-col>
                            </b-row>
                        </div>
                        <div class="variation px-3 add-variation">
                            <b-row no-gutters>
                                <b-col style="cursor: pointer;" @click="addVariationEdit(index)">
                                    <img src="@/assets/images/icons/add.svg"
                                        alt="Add Button"
                                        class="add-variation-button mr-2">
                                    <label class="mb-0" style="position: absolute; top: 2px; cursor: pointer;">
                                        Add Option
                                    </label>   
                                </b-col>
                            </b-row>
                        </div>
                        <div class="py-2 px-3 pr-0 bg-white">
                            <b-form inline v-on:submit.prevent>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref">Maximum Selection</label>
                                <b-form-input
                                    disabled
                                    type="number"
                                    style="width: 80px;"
                                    min="1"
                                    v-model="attribute.limit"
                                    max="10000000000"
                                    oninput="this.value = Math.abs(this.value)">
                                </b-form-input>
                            </b-form>
                        </div>
                    </div>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "AdOns",
    props: ["values", "origin"],
    computed: {
        ...mapState("estoreInventories", ["errors"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        enableGenerate: {
            get() {
                return "attributes" in this.values && this.values.attributes.length > 0
                    ? !this.values.attributes[0].name || !this.values.attributes[0].variations[0].name
                    : this.values.length <= 0 || this.values.length > 0 && (!this.values[0].name || !this.values[0].add_ons[0].name);
            },
            set(is_enabled) {
                return is_enabled;
            }
        }
    },
    methods: {
        addAttributeAdOn: function() {
            this.$emit("addAttributeAdOn", {
                uuid: null,
                action: "create",
                name: "",
                limit: 1,
                variations: [
                    {
                        action: "create",
                        name: ""
                    }
                ]
            });
        },
        generate: function() {
            this.$emit("generateVariationsAdOn");
        },
        addVariation: function(index) {
            this.$emit("addVariationAdOn", index);
        },
        addAttributeAdOnEdit: function() {
            this.$emit("addAttributeAdOnEdit", {
                uuid: null,
                action: "create",
                name: "",
                limit: 1,
                add_ons: [
                    {
                        action: "create",
                        uuid: null,
                        name: "",
                        currency: "PHP",
                        price: "1",
                        sku: null,
                        visibility: 1,
                        free: 0
                    }
                ]
            });
        },
        generateEdit: function() {
            this.$emit("generateVariationsAdOnEdit");
        },
        addVariationEdit: function(index) {
            this.$emit("addVariationAdOnEdit", index);
        },
        deleteVariation: function(param) {
            this.$emit("deleteVariationAdOn", param);
        },
        deleteVariationAdOnEdit: function(param) {
            this.$emit("deleteVariationAdOnEdit", param);
            this.$root.$emit("bv::hide::popover");
        },
        deleteAttribute: function(index) {
            this.$emit("deleteAttributeAdOn", index);
        },
        deleteAttributeAdOnEdit: function(index) {
            this.$emit("deleteAttributeAdOnEdit", index);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        }
    }
};
</script>
